import AreaChart from "components/common/AreaChart/AreaChart";
import Typography from "components/common/Typography/Typography";
import { getChartDummyData } from "helpers/generateDummyChartData";
import {
  CHART_HEADING,
  CHART_SUBTITLE,
  GRAPH_API_CONNECTED,
} from "config/profile_constants";
import React from "react";
import styled from "styled-components";

export const ProfileVisualizationSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
`;
export const Subtitle = styled(Typography)`
  font-size: 25px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: -0.023em;
  text-align: left;
  margin-bottom: 72px;
`;

const Section = ({
  showHeading,
  children,
  heading,
  subHeading,
  showSubheading,
}) => {
  const [chartData, setChartData] = React.useState([]);
  const getChartData = () => {
    if (GRAPH_API_CONNECTED) {
      // ATTACH API HERE
    } else {
      setChartData([...getChartDummyData(365)]);
    }
  };
  const init = () => {
    getChartData();
  };
  React.useEffect(() => {
    init();
  }, []);

  return (
    <ProfileVisualizationSectionWrapper>
      {showHeading ? (
        <>
          <Typography variant={"h1"}>{heading}</Typography>
          {showSubheading ? <Subtitle>{subHeading}</Subtitle> : null}
        </>
      ) : null}
      {children}
    </ProfileVisualizationSectionWrapper>
  );
};

Section.defaultProps = {
  showHeading: false,
  showSubheading: false,
  children: <>no children provided</>,
  heading: "No heading given",
  subHeading: "No subheading given",
};

export default Section;
